import ListBuilder from '../ListBuilder/ListBuilder';
import TimeBlocks from '../TimeBlocks/TimeBlocks';
import Itinerary from '../Itinerary/Itinerary';
import LoadingState from '../shared/LoadingState';
import LocationInfoOverlay from '../shared/LocationInfoOverlay';
import TravelModeSelector from '../shared/TravelModeSelector';
import GoogleMapsStatus from '../shared/GoogleMapsStatus';
import useTripStore from '../../context/TripStore';

/**
 * Desktop layout with fixed left sidebar
 * Preserves existing desktop experience
 */
function DesktopLayout() {
  const currentStep = useTripStore((state) => state.ui?.currentStep ?? 'list');
  const isGenerating = useTripStore((state) => state.ui?.isGenerating ?? false);

  const renderStep = () => {
    try {
      switch (currentStep) {
        case 'setup':
        case 'list':
          return <ListBuilder />;
        case 'timeblocks':
          return <TimeBlocks />;
        case 'itinerary':
          return <Itinerary />;
        default:
          return <ListBuilder />;
      }
    } catch (error) {
      console.error('Error rendering step:', error);
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          Error rendering: {error.message}
        </div>
      );
    }
  };

  return (
    <>
      {/* Left-aligned navbar overlay */}
      <nav
        className="fixed left-0 top-0 h-full w-96 z-20 overflow-y-auto"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(10px)',
          pointerEvents: 'auto',
        }}
      >
        <div className="h-full">
          {/* Debug fallback */}
          {!currentStep && (
            <div
              style={{
                padding: '20px',
                fontFamily: 'monospace',
                fontSize: '12px',
              }}
            >
              Debug: currentStep is undefined. Store state:{' '}
              {JSON.stringify({ currentStep, isGenerating })}
            </div>
          )}
          {isGenerating ? (
            <div className="flex items-center justify-center min-h-screen">
              <LoadingState message="Generating your itinerary..." />
            </div>
          ) : (
            renderStep()
          )}
        </div>
      </nav>

      {/* Location info overlay (start/end points) */}
      <LocationInfoOverlay />

      {/* Travel mode selector */}
      <TravelModeSelector />

      {/* Google Maps status (only shows if there's an issue) */}
      <GoogleMapsStatus />
    </>
  );
}

export default DesktopLayout;
